/**
 * Connect POS — Configuración de impresión térmica persistida por taquilla.
 *
 * Se guarda en localStorage bajo `connect_printer_settings`:
 *  - paper_size: '58mm' | '80mm'            (default '58mm')
 *  - print_method: 'browser' | 'bluetooth' | 'serial'  (default 'browser'; serial = ESC/POS directo por Web Serial)
 *  - serial_baud: number                    (baudios del puerto serie, default 9600)
 *  - auto_print_on_sell: boolean            (default true)
 *  - feed_lines: number                     (saltos de línea finales, default 4; ESC/POS nunca envía menos de 4)
 *  - cut_paper: boolean                     (corte ESC/POS al final, default true)
 *  - kiosk_printing: boolean                (terminal Chromium con --kiosk-printing: impresión silenciosa
 *                                            y cierre automático del recibo tras imprimir, default false)
 */

const LS_KEY = "connect_printer_settings";

export const DEFAULT_PRINTER_SETTINGS = {
  paper_size: "58mm",
  print_method: "browser",
  auto_print_on_sell: true,
  feed_lines: 4,
  cut_paper: true,
  kiosk_printing: false,
  serial_baud: 9600,
  desktop_mode: "raw",
};

export function getPrinterSettings() {
  try {
    const raw = localStorage.getItem(LS_KEY);
    if (!raw) return { ...DEFAULT_PRINTER_SETTINGS };
    const parsed = JSON.parse(raw);
    return { ...DEFAULT_PRINTER_SETTINGS, ...parsed };
  } catch {
    return { ...DEFAULT_PRINTER_SETTINGS };
  }
}

export function savePrinterSettings(settings) {
  const merged = { ...getPrinterSettings(), ...(settings || {}) };
  // Normaliza tipos
  merged.feed_lines = Math.max(0, Math.min(10, parseInt(merged.feed_lines, 10) || 0));
  merged.auto_print_on_sell = !!merged.auto_print_on_sell;
  merged.cut_paper = !!merged.cut_paper;
  merged.kiosk_printing = !!merged.kiosk_printing;
  if (merged.paper_size !== "80mm") merged.paper_size = "58mm";
  if (!["bluetooth", "serial"].includes(merged.print_method)) merged.print_method = "browser";
  merged.serial_baud = parseInt(merged.serial_baud, 10) || 9600;
  if (merged.desktop_mode !== "graphic") merged.desktop_mode = "raw";
  localStorage.setItem(LS_KEY, JSON.stringify(merged));
  return merged;
}
